import "../styles/ConfirmationPage.css"; 

const ConfirmationPage = () => {
 
  return (
    <div className="confirmation-container">
      <h1>🎉 Congratulations! 🎉</h1>
      <p>Thank you for completing the exam.</p>
      <p>Check your email for further details.</p>
     
    </div>
  );
};

export default ConfirmationPage;
